// ProtectedRoute.js
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useCurrentUser } from "../context/UserContext";
import LoadingScreen from "../LoadingScreen";

const ProtectedRoute = ({ redirectPath = "/authentication", requiredFlag, children }) => {
  const { currentUser, loading } = useCurrentUser();
  if (loading) {
    return <LoadingScreen />;
  }
  if (!currentUser) {
    return <Navigate to={redirectPath} replace />;
  }
  if (currentUser && !currentUser?.has_access) {
    return <Navigate to="/perfil" replace />;
  }
  if (
    requiredFlag &&
    !currentUser?.is_superuser &&
    !currentUser?.[requiredFlag]
  ) {
    return <Navigate to="/" replace />;
  }
  return children ? children : <Outlet />;
};

export default ProtectedRoute;
